import { GridCell } from '@progress/kendo-react-grid'
import Resx from '@/components/Resx'
import React from 'react'

function createApprovalStatusCell (approvalInfo, name, items) {
  return class ApprovalStatusCell extends GridCell {
    static omitFromExport = true
    render () {
      const { dataItem } = this.props
      const item = items.find(x => x.id === dataItem.id)
      const index = items.indexOf(item)
      const prefix = `${name}[${index}]`
      const approved = approvalInfo ? approvalInfo.filter((v, k) => k.startsWith(prefix)) : null
      if (approved) {
        if (approved.filter(v => v === false).size > 0) {
          return <td className='td-status'><span className='status status--3'><Resx name='Common.Rejected' /></span></td>
        }
        if (approved.filter(v => v === true).size === approved.size) {
          return <td className='td-status'><span className='status status--2'><Resx name='Common.Approved' /></span></td>
        }
      }
      return <td className='td-status'><span className='status status--0'><Resx name='Common.Pending' /></span></td>
    }
  }
}

export {
  createApprovalStatusCell
}



// WEBPACK FOOTER //
// ./src/components/changeRequests/approvalStatusCell.js